<style src="css/task.css" scoped></style>
<template>
    <div style="padding-top: .98rem;padding-bottom: 1rem">
        <div class="topBox">任务</div>
        <div class="tabBox">
            <div class="tab">
                <span :class="{'active':workStatus===-1}" @click="changeWorkStatus(-1)">新任务 <span v-if="newWorkCount">({{newWorkCount}})</span></span>
            </div>
            <div class="tab"><span :class="{'active':workStatus===0||workStatus===1||workStatus===2}" @click="changeWorkStatus(0)">我的 <span v-if="noCommitCount">({{noCommitCount}})</span></span></div>
            <div class="tab"><span :class="{'active':workStatus===3}" @click="changeWorkStatus(3)">未通过 <span  v-if="noPassCount">({{noPassCount}})</span></span></div>
        </div>
        <div class="box" v-if="workStatus===-1">
            <div class="newItemBox" v-for="item in workList">
                <div class="newItemTop">
                    <div class="newItemTopLeft">
                        <div class="newItemIcon"></div>
                        {{item.groupTitle}}
                    </div>
                    <div class="receiveBtn" @click="doReceiveWork(item.comboId)">领取任务</div>
                </div>
                <div class="info">
                    <span>用户姓名</span>：{{item.userName}}
                </div>
<!--                <div class="info">-->
<!--                    <span><div>性</div><div>别</div></span>：{{安吉拉}}-->
<!--                </div>-->
                <div class="info">
                    <span>联系方式</span>：{{item.userPhone}}
                </div>
                <div class="info">
                    <span>测试时间</span>：{{item.createTime | time }}
                </div>
                <div class="info">
                  <span>区域名称</span>：{{item.userArea}}
                </div>
            </div>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </div>
        <div class="box" v-if="workStatus===3">
            <div class="newItemBox" v-for="item in workList"  @click="to(`taskDetail?workId=${item.workId}`)">
                <div class="newItemTop">
                    <div class="newItemTopLeft">
                        <div class="newItemIcon"></div>
                        {{item.groupTitle}}
                    </div>
<!--                    <div class="receiveBtn" @click="doReceiveWork(item.comboId)">领取任务</div>-->
                </div>
                <div class="info">
                    <span>用户姓名</span>：{{item.userName}}
                </div>
<!--                <div class="info">-->
<!--                    <span><div>性</div><div>别</div></span>：{{安吉拉}}-->
<!--                </div>-->
                <div class="info">
                    <span>联系方式</span>：{{item.userPhone}}
                </div>
                <div class="info">
                    <span>测试时间</span>：{{item.createTime | time }}
                </div>

                <div class="info">
                  <span>区域名称</span>：{{item.userArea}}
                </div>
            </div>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </div>
        <div class="box" v-if="workStatus===0||workStatus===1||workStatus===2">
            <div class="flexBox">
                <div class="statusBox">
                    <div class="statusItem" :class="{'actived':workStatus===0}" @click="changeWorkStatus(0)">未提交 {{workStatus===0?count:''}}</div>
                    <div class="statusItem" :class="{'actived':workStatus===1}" @click="changeWorkStatus(1)">已提交 {{workStatus===1?count:''}}</div>
                    <div class="statusItem" :class="{'actived':workStatus===2}" @click="changeWorkStatus(2)">已通过 {{workStatus===2?count:''}}</div>
                </div>
            </div>

            <div class="newItemBox" v-for="item in workList" @click="to(`taskDetail?workId=${item.workId}`)">
                <div class="newItemTop">
                    <div class="newItemTopLeft">
                        <div class="newItemIcon"></div>
                        {{item.groupTitle}}
                    </div>
<!--                    <div class="receiveBtn" @click="doReceiveWork(item.comboId)">领取任务</div>-->
                </div>
                <div class="info">
                    <span>用户姓名</span>：{{item.userName}}
                </div>
<!--                <div class="info">-->
<!--                    <span><div>性</div><div>别</div></span>：{{安吉拉}}-->
<!--                </div>-->
                <div class="info">
                    <span>联系方式</span>：{{item.userPhone}}
                </div>
                <div class="info">
                    <span>测试时间</span>：{{item.createTime | time }}
                </div>

                <div class="info">
                  <span>区域名称</span>：{{item.userArea}}
                </div>
            </div>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </div>
        <footerBox active="5"></footerBox>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import footerBox from 'components/footer'
    import moment from 'moment/moment'


    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                pageIndex:1,
                pageSize: 10,
                count: 0,
                newWorkCount: 0,
                noCommitCount: 0,
                noPassCount: 0,
                noMoreData: false,
                isLoading:false,
                workList:[],
                workStatus:-1,
            }
        },
        components: {
            noMoreData,
            topbar,
            footerBox,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {

            to(n) {
                this.$router.push(`/${n}`)
            },
            changeWorkStatus(n){
                this.noMoreData=false;
                this.workList=[];
                this.pageIndex=1;
                this.workStatus=n;
                this.getWorkList();
            },
            async getWorkList() {
                let data = await getSources("/bear-scale/api/scaleGroupCombo/getWorkList.json",{
                    doctorId:localStorage.getItem('doctorId'),
                    workStatus:this.workStatus,
                    pageIndex:this.pageIndex,
                    pageSize:10
                });
                if (data.status === 0) {
                    this.newWorkCount=0;
                    this.noCommitCount=0;
                    this.noPassCount=0;
                    this.isLoading = false;
                    this.count = data.count;
                    if(data.newWorkCount){
                        this.newWorkCount=data.newWorkCount
                    }
                    if(data.noCommitCount){
                        this.noCommitCount=data.noCommitCount
                    }
                    if(data.noPassCount){
                        this.noPassCount=data.noPassCount
                    }
                    this.workList = [...this.workList, ...data.workList];
                    if (data.workList.length === 0) {
                        this.noMoreData = true
                    } else {
                        console.log(111111)
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            console.log(2)
                            this.noMoreData = false
                        }
                    }
                }else{
                    alert(data.msg)
                }
            },
            async doReceiveWork(comboId) {
                let data = await getSources("/bear-scale/api/scaleGroupCombo/doReceiveWork.json",{
                    doctorId:localStorage.getItem('doctorId'),
                    comboId:comboId
                });
                if (data.status === 0) {
                    this.$router.push(`/taskDetail?workId=${data.workId}`)
                }else{
                    alert(data.msg)
                }
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {
                    console.log(bottomOfWindow)
                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getWorkList()
                    }
                }
            },
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.getWorkList()
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/task.vue